import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LogsRequestDTO } from '../models/logs-request-payload.model';

@Injectable({
  providedIn: 'root',
})
export class WebsiteLogsService {
  private http = inject(HttpClient);

  requestLogs({ websiteId, type, lines, userId }: LogsRequestDTO): Observable<void> {
    const httpHeaders = new HttpHeaders({
      'x-user-id': userId,
    });

    return this.http.get<void>(`/logs/${websiteId}/${type}?lines=${lines}`, {
      headers: httpHeaders,
    });
  }
}
